export interface TechnicalError {
  code: ErrorCode;
  message: string;
}

export enum ErrorCode {
  AddressMalformed = 'address_malformed' as any,
  AliasUnknown = 'alias_unknown' as any,
  InvalidMsisdn = 'invalid_msisdn' as any,
  InvalidToken = 'invalid_token' as any,
  MailboxAliasMalformed = 'mailbox_alias_malformed' as any,
  MailboxAliasMaxNumberExceeded = 'mailbox_alias_max_number_exceeded' as any,
  MailboxAliasNotUnique = 'mailbox_alias_not_unique' as any,
  MailboxCreationFailed = 'mailbox_address_malformed' as any,
  MailboxLoadFail = 'mailbox_technical_error' as any,
  MailboxUnknown = 'mailbox_unknown' as any,
  PasswordMalformed = 'password_malformed' as any,
  PasswordValidationError = 'password_validation_failed' as any,
  EmailValidationError = 'EMAIL-INVALID' as any,
  RecoveryAddressMalformed = 'recovery_address_malformed' as any,
  TechnicalError = 'technical_error' as any,
  TokenDoesNotMatch = 'token_does_not_match' as any,
  TokenNotFound = 'token_not_found' as any,
  MailBoxesNotFound = 'mailboxes_not_found' as any,
}
